<template>
  <div @click.stop.prevent="changePayment" class="col-24 col-lg d-flex">
    <slot />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "PaymentButtonWrapper",
  props: {
    id: {
      type: String,
      required: true,
    },
    lyticsActivities: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      childClasses: null,
    };
  },
  computed: {
    ...mapGetters({
      activePayment: "checkoutPayment/getActivePayment",
    }),
  },
  watch: {
    activePayment() {
      this.setButtonBorder();
    },
  },
  mounted() {
    this.childClasses = this.$el.children[0].classList;
    this.setButtonBorder();

    if (this.activePayment === this.id) {
      this.sendLyticsActivities(this.lyticsActivities);
    }
  },
  methods: {
    setButtonBorder() {
      this.childClasses.remove("border-secondary");
      if (this.activePayment === this.id) {
        this.childClasses.add("border-secondary");
      }
    },
    ...mapActions({
      setActivePayment: "checkoutPayment/setActivePayment",
      sendLyticsActivities: "lytics/sendLyticsActivities",
    }),
    changePayment() {
      if (this.activePayment === this.id) return;

      this.setActivePayment(this.id);
      this.sendLyticsActivities(this.lyticsActivities);
    },
  },
};
</script>
